
import { combineReducers } from 'redux';
import { loaderReducer } from './loader';


export default combineReducers({
    loader: loaderReducer
})